// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatThinkingIndicator-moduleelapsed__KzBDT GretaAIChatThinkingIndicator-modulelabel__hIWPJ";
var _2 = "GretaAIChatThinkingIndicator-moduleindicator__kuHlg";
var _3 = "GretaAIChatThinkingIndicator-modulelabel__hIWPJ";
var _4 = "GretaAIChatThinkingIndicator-modulemark__bUkAf";
export { _1 as "elapsed", _2 as "indicator", _3 as "label", _4 as "mark" }
